import { render, staticRenderFns } from "./monthlyBill.vue?vue&type=template&id=ddb4dd1a&scoped=true&"
import script from "./monthlyBill.vue?vue&type=script&lang=js&"
export * from "./monthlyBill.vue?vue&type=script&lang=js&"
import style0 from "./monthlyBill.vue?vue&type=style&index=0&id=ddb4dd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb4dd1a",
  null
  
)

export default component.exports